import { Icon } from './Icons';

const styles = {
  sidebar: { width: 250, minWidth: 250, background: 'var(--warm)', borderRight: '1.5px solid var(--border2)', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 200, display: 'flex', flexDirection: 'column', boxShadow: '4px 0 20px rgba(180,80,100,.06)', transition: 'transform .35s cubic-bezier(.4,0,.2,1)' },
  sidebarCollapsed: { transform: 'translateX(-250px)' },
  stripe: { height: 5, flexShrink: 0, background: 'linear-gradient(90deg, var(--crimson), var(--rose), var(--periwinkle), var(--sage), var(--gold))' },
  scroll: { flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', paddingBottom: 20 },
  profile: { padding: '22px 18px 16px', textAlign: 'center', borderBottom: '1.5px solid var(--border)' },
  avatarWrap: { position: 'relative', display: 'inline-block', marginBottom: 12 },
  avatar: { width: 84, height: 84, borderRadius: '50%', border: '3px solid white', boxShadow: '0 0 0 3px var(--deep-rose), var(--shadow)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--rose), var(--periwinkle))', fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: 'white' },
  avatarBadge: { position: 'absolute', bottom: 2, right: 2, background: 'var(--deep-sage)', width: 18, height: 18, borderRadius: '50%', border: '2px solid white', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  sName: { fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: 'var(--ink)', marginBottom: 2 },
  sTitle: { fontSize: 12, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--deep-rose)', marginBottom: 5 },
  sLoc: { fontSize: 13, color: 'var(--text3)', marginBottom: 9 },
  statusPill: { display: 'inline-flex', alignItems: 'center', gap: 5, background: 'rgba(74,145,120,.1)', border: '1px solid rgba(74,145,120,.3)', color: 'var(--deep-sage)', fontSize: 12, fontWeight: 800, padding: '3px 10px', borderRadius: 20, letterSpacing: '.05em' },
  navSec: { padding: '12px 12px 0' },
  navLbl: { fontFamily: "'Courier Prime', monospace", fontSize: 11, letterSpacing: '.15em', textTransform: 'uppercase', color: 'var(--text3)', padding: '0 8px', marginBottom: 5, marginTop: 8, display: 'block' },
  footer: { padding: '16px 18px 0', borderTop: '1.5px solid var(--border)', marginTop: 'auto' },
  footerLbl: { fontFamily: "'Courier Prime', monospace", fontSize: 11, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--text3)', marginBottom: 8 },
};

const NavItem = ({ icon, label, pageId, currentPage, onNavigate }) => {
  const isActive = currentPage === pageId;
  return (
    <button
      onClick={() => onNavigate(pageId)}
      style={{
        display: 'flex', alignItems: 'center', gap: 9,
        padding: '8px 10px', borderRadius: 10,
        fontSize: 15, fontWeight: 700,
        color: isActive ? 'var(--crimson)' : 'var(--text2)',
        background: isActive ? 'linear-gradient(135deg, var(--blush), var(--lavender))' : 'none',
        border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left',
        marginBottom: 2, transition: 'all .15s', fontFamily: "'Nunito', sans-serif",
      }}
      onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = 'var(--blush)'; e.currentTarget.style.color = 'var(--crimson)'; }}}
      onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = 'var(--text2)'; }}}
    >
      <span style={{ width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon name={icon} size={16} stroke="currentColor" />
      </span>
      {label}
    </button>
  );
};

const btnStyle = { display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '7px 11px', borderRadius: 8, border: '1.5px solid var(--border2)', background: 'white', color: 'var(--text)', fontFamily: "'Nunito', sans-serif", fontSize: 14, fontWeight: 700, cursor: 'pointer', textDecoration: 'none', marginBottom: 6, transition: 'all .15s' };
const hoverOn = e => { e.currentTarget.style.borderColor = 'var(--deep-rose)'; e.currentTarget.style.color = 'var(--crimson)'; e.currentTarget.style.background = 'var(--blush)'; e.currentTarget.style.transform = 'translateX(2px)'; };
const hoverOff = e => { e.currentTarget.style.borderColor = 'var(--border2)'; e.currentTarget.style.color = 'var(--text)'; e.currentTarget.style.background = 'white'; e.currentTarget.style.transform = 'none'; };

const ContactBtn = ({ icon, label, href, onClick }) => {
  if (onClick) {
    return (
      <button onClick={onClick} style={btnStyle} onMouseEnter={hoverOn} onMouseLeave={hoverOff}>
        <Icon name={icon} size={14} stroke="var(--deep-rose)" />
        {label}
      </button>
    );
  }
  return (
    <a href={href} style={btnStyle} onMouseEnter={hoverOn} onMouseLeave={hoverOff}>
      <Icon name={icon} size={14} stroke="var(--deep-rose)" />
      {label}
    </a>
  );
};

export default function Sidebar({ content, currentPage, onNavigate, isOpen, onToggle, isMobile }) {
  const profile = content?.profile || {};

  return (
    <>
      {/* Toggle button */}
      <button className="no-print" onClick={onToggle} style={{
        position: 'fixed',
        top: isMobile ? 12 : 16,
        left: isMobile ? (isOpen ? 262 : 12) : 12,
        zIndex: 300,
        width: 36, height: 36,
        background: 'var(--crimson)', border: 'none', borderRadius: '50%', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 3px 12px rgba(196,104,122,.45)', transition: 'all .35s cubic-bezier(.4,0,.2,1)', color: 'white',
      }}
        onMouseEnter={e => { e.currentTarget.style.background = 'var(--ink)'; e.currentTarget.style.transform = 'scale(1.08)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'var(--crimson)'; e.currentTarget.style.transform = 'none'; }}
      >
        <Icon name={isOpen ? 'close' : 'menu'} size={15} stroke="white" />
      </button>

      <aside className="no-print" style={{ ...styles.sidebar, ...(!isOpen ? styles.sidebarCollapsed : {}) }}>
        <div style={styles.stripe} />
        <div style={styles.scroll}>
          {/* Profile */}
          <div style={styles.profile}>
            <div style={styles.avatarWrap}>
              <div style={styles.avatar}>
                {profile.photo
                  ? <img src={profile.photo} alt={profile.name} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />
                  : 'MR'
                }
              </div>
              <div style={styles.avatarBadge}>
                <Icon name="check" size={10} stroke="white" />
              </div>
            </div>
            <div style={styles.sName}>{profile.name || 'Makayla Richards'}</div>
            <div style={styles.sTitle}>{profile.title || 'Director of Social & Brand Strategy'}</div>
            <div style={styles.sLoc}>{profile.location || 'Atlanta, GA'}</div>
            <div style={styles.statusPill}>
              <span className="status-dot" />
              {profile.status || 'Open to Opportunities'}
            </div>
          </div>

          {/* Nav */}
          <nav style={styles.navSec}>
            <span style={styles.navLbl}>Dashboard</span>
            <NavItem icon="home" label="Overview" pageId="overview" currentPage={currentPage} onNavigate={onNavigate} />
            <NavItem icon="person" label="About" pageId="about" currentPage={currentPage} onNavigate={onNavigate} />
            <NavItem icon="chart" label="Metrics" pageId="metrics" currentPage={currentPage} onNavigate={onNavigate} />
          </nav>
          <nav style={styles.navSec}>
            <span style={styles.navLbl}>Work</span>
            <NavItem icon="bulb" label="Skills" pageId="skills" currentPage={currentPage} onNavigate={onNavigate} />
            <NavItem icon="play" label="Portfolio" pageId="portfolio" currentPage={currentPage} onNavigate={onNavigate} />
            <NavItem icon="gear" label="Systems Built" pageId="systems" currentPage={currentPage} onNavigate={onNavigate} />
            <NavItem icon="trophy" label="Recognition" pageId="awards" currentPage={currentPage} onNavigate={onNavigate} />
            <NavItem icon="calendar" label="Timeline" pageId="timeline" currentPage={currentPage} onNavigate={onNavigate} />
          </nav>

          {/* Footer */}
          <div style={styles.footer}>
            <div style={styles.footerLbl}>Let's Connect</div>
            <ContactBtn icon="email" label="Email Me" onClick={() => window.dispatchEvent(new CustomEvent('mr:openContact'))} />
            <ContactBtn icon="linkedin" label="LinkedIn" href={profile.linkedin || '#'} />
            <ContactBtn icon="resume" label="Resume" href={profile.resumeUrl || '#resume'} />
            {(profile.links || []).map(l => (
              <ContactBtn key={l.id} icon="link" label={l.label || 'Link'} href={l.url || '#'} />
            ))}
          </div>
        </div>
      </aside>
    </>
  );
}
